import React, { useState, useEffect, useCallback, useRef } from 'react';
import { apiFetch } from '../lib/api';
import { tagClass, statusName, quotaVal, industryLabel } from '../lib/tenant';
import { Icons } from '../components/icons';

export function StationTerminalSettings() {
  const [form, setForm] = useState({ host: '', port: 1883, username: '', password: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [msg, setMsg] = useState('');

  const load = useCallback(() => {
    setLoading(true);
    apiFetch('/api/v1/platform/station-mqtt').then(d => {
      if (d.code === 0 && d.data) {
        setForm({
          host: d.data.host || '',
          port: d.data.port || 1883,
          username: d.data.username || '',
          password: d.data.password || '',
        });
      }
      setLoading(false);
    });
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = async () => {
    if (!form.host.trim()) { setMsg('请填写 Broker 地址'); return; }
    setSaving(true); setMsg('');
    const body = { ...form, port: parseInt(form.port, 10) || 1883 };
    const d = await apiFetch('/api/v1/platform/station-mqtt', { method: 'PUT', body });
    setSaving(false);
    if (d.code === 0) {
      setMsg('已保存，工位 App 下次同步时将自动应用');
      if (d.data) setForm(f => ({ ...f, ...d.data }));
    } else {
      setMsg(d.message || '保存失败');
    }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
        <div>
          <h2 style={{ fontSize: 18, fontWeight: 650 }}>工位终端 · MQTT 配置</h2>
          <p style={{ fontSize: 13, color: 'var(--brand-text-muted)', marginTop: 4 }}>
            统一配置工位 App 连接 MQTT Broker 的地址与凭据，工位端不再单独填写用户名密码。
          </p>
        </div>
        <button className="btn btn-outline" onClick={load} disabled={loading}><Icons.Refresh/>刷新</button>
      </div>

      {loading ? <div className="empty"><span className="spinner"/></div> : (
        <div className="card" style={{ maxWidth: 560 }}>
          <div className="form-group">
            <label>Broker 地址</label>
            <input className="form-input" value={form.host} onChange={e => setForm(f => ({ ...f, host: e.target.value }))} placeholder="如 47.113.200.150"/>
          </div>
          <div className="form-group">
            <label>端口</label>
            <input className="form-input" type="number" value={form.port} onChange={e => setForm(f => ({ ...f, port: e.target.value }))} placeholder="1883"/>
          </div>
          <div className="form-group">
            <label>用户名</label>
            <input className="form-input" value={form.username} onChange={e => setForm(f => ({ ...f, username: e.target.value }))} placeholder="MQTT 用户名"/>
          </div>
          <div className="form-group">
            <label>密码</label>
            <input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} placeholder="留空则保持原密码"/>
          </div>
          {msg && <div className={msg.includes('失败') ? 'error' : 'lc-badge'} style={{ marginBottom: 12 }}>{msg}</div>}
          <button className="btn btn-primary" onClick={save} disabled={saving}>{saving ? '保存中…' : '保存配置'}</button>
        </div>
      )}
    </div>
  );
}

